export default __webpack_public_path__ + "static/media/chevron-right_orange.4b29cb12.svg";